var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoParametrageInactifFond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 10.583333 10.583334",
    height: 36,
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    y: 0,
    x: 0,
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 25.23,
    height: 21.906
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943-6",
    "data-name": "Rectangle 943",
    width: 25.23,
    height: 21.906,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.94373,-142.88417)",
    style: {
      display: "inline"
    },
    id: "layer2"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 2.7,
    rx: 2.7,
    y: 142.88417,
    x: 100.94373,
    height: 10.583333,
    width: 10.583333,
    id: "rect104",
    style: {
      opacity: 1,
      fill: "#f3f4f8",
      fillOpacity: 1,
      strokeWidth: 0.35277689
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.94373,-142.88417)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2981",
    "data-name": "Groupe 2981",
    transform: "matrix(0.26458333,0,0,0.26458333,79.331244,131.30856)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_147",
    "data-name": "Ligne 147",
    y2: 10.368,
    transform: "translate(93.973,63.482)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_148",
    "data-name": "Ligne 148",
    y2: 2.325,
    transform: "translate(93.973,55.011)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_149",
    "data-name": "Ligne 149",
    y2: 2.4319999,
    transform: "translate(101.756,71.418)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_150",
    "data-name": "Ligne 150",
    y2: 9.9300003,
    transform: "translate(101.756,55.011)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_151",
    "data-name": "Ligne 151",
    y2: 8.7670002,
    transform: "translate(109.538,65.083)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x2: 0,
    y1: 0,
    x1: 0,
    id: "Ligne_152",
    "data-name": "Ligne 152",
    y2: 3.6300001,
    transform: "translate(109.538,55.011)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 2.99,
    cy: 2.99,
    r: 2.99,
    transform: "translate(90.936,57.336)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.99,
    cy: 2.99,
    r: 2.99,
    transform: "translate(106.454,58.855)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 2.99,
    cy: 2.99,
    r: 2.99,
    transform: "translate(98.731,65.214)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "#42516c",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    id: "Trac\\xE9_1097",
    "data-name": "Trac\\xE9 1097",
    d: "M 106.278,48.89",
    transform: "translate(-7.607)",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoParametrageInactifFond);
export default __webpack_public_path__ + "static/media/picto-parametrage-inactif-fond.59dde07b88ae2c958304177802916cce.svg";
export { ForwardRef as ReactComponent };